import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MapPin, Users } from '../components/icons';

const EventsSection = () => {
  const events = [
    {
      id: 'aesthetic-dentistry',
      title: 'Aesthetic Dentistry',
      description: 'Advanced training in cosmetic dental procedures and smile design techniques',
      date: 'March 2024',
      location: 'Dar es Salaam',
      attendees: '50+',
      image: '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_01.jpg',
      images: [
        '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_01.jpg',
        '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_02.jpg',
        '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_03.jpg',
        '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_04.jpg',
        '/images/Events/Aesthetic Dentistry/Aesthetic-Dentistry_05.jpg',
      ],
      category: 'Training'
    },
    {
      id: 'cention-phase-1',
      title: 'Cention N Phase 1',
      description: 'Introduction to mercury-free filling materials and Cention N system implementation',
      date: 'February 2024',
      location: 'Multiple Cities',
      attendees: '100+',
      image: '/images/Events/Cention n phase 1/Cention-workshop_01.jpg',
      images: [
        '/images/Events/Cention n phase 1/Cention-workshop_01.jpg',
        '/images/Events/Cention n phase 1/Cention-workshop_02.jpg',
        '/images/Events/Cention n phase 1/Cention-workshop_03.jpg',
        '/images/Events/Cention n phase 1/Cention-workshop_04.jpg',
        '/images/Events/Cention n phase 1/Cention-workshop_05.jpg',
      ],
      category: 'Workshop'
    },
    {
      id: 'cention-phase-2',
      title: 'Cention N Phase 2',
      description: 'Advanced techniques and hands-on practice with Cention N restorative materials',
      date: 'April 2024',
      location: 'Regional Centers',
      attendees: '75+',
      image: '/images/Events/Cention n phase 2/Cention-workshop2_01.jpg',
      images: [
        '/images/Events/Cention n phase 2/Cention-workshop2_01.jpg',
        '/images/Events/Cention n phase 2/Cention-workshop2_02.jpg',
        '/images/Events/Cention n phase 2/Cention-workshop2_03.jpg',
        '/images/Events/Cention n phase 2/Cention-workshop2_04.jpg',
        '/images/Events/Cention n phase 2/Cention-workshop2_05.jpg',
      ],
      category: 'Workshop'
    },
    {
      id: 'ksi-meeting',
      title: 'KSI Meeting',
      description: 'Knowledge sharing and industry collaboration with dental professionals',
      date: 'May 2024',
      location: 'Nairobi',
      attendees: '30+',
      image: '/images/Events/KSI meeting/KSI-meeting_01.jpg',
      images: [
        '/images/Events/KSI meeting/KSI-meeting_01.jpg',
        '/images/Events/KSI meeting/KSI-meeting_02.jpg',
      ],
      category: 'Conference'
    }
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What We've Been Up To
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with our latest events, workshops, and industry collaborations 
            across East Africa
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {events.map((event, index) => (
            <motion.div
              key={event.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group-hover:scale-105">
                {/* Event Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </div>

                {/* Event Content */}
                <div className="p-6">
                  {/* Event Category Badge */}
                  <div className="mb-3">
                    <span className="bg-[#8EC641] text-white text-xs font-bold px-3 py-1 rounded-full">
                      {event.category}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0D56A6] transition-colors">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {event.description}
                  </p>

                  {/* Event Details */}
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-sm text-gray-500">
                      <Calendar size={16} className="mr-2 text-[#0D56A6]" />
                      {event.date}
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <MapPin size={16} className="mr-2 text-[#0D56A6]" />
                      {event.location}
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <Users size={16} className="mr-2 text-[#0D56A6]" />
                      {event.attendees} attendees
                    </div>
                  </div>

                  {/* View More Button */}
                  <Link
                    to={`/events/${event.id}`}
                    className="inline-flex items-center text-[#0D56A6] hover:text-[#0A4A8F] font-semibold text-sm group-hover:translate-x-1 transition-transform"
                  >
                    View Details
                    <ArrowRight size={14} className="ml-1" />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link
            to="/events"
            className="inline-flex items-center justify-center bg-[#0D56A6] hover:bg-[#0A4A8F] text-white font-bold text-lg px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            <span>View All Events</span>
            <ArrowRight size={20} className="ml-2" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default EventsSection;
